import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

import { NETWORK_THREAT_PATH } from "@js2/path";
import { getRoute } from "@modules/network/components/common/NetworkLink";
import { useNetworkRoute } from "@modules/network/hooks/useNetworkRoute";

const AttributionNavItem = () => {
  const [name = "", value = ""] = useNetworkRoute();
  const route = getRoute(NETWORK_THREAT_PATH.ATTRIBUTION_DATA, name, value);
  return (
    <Nav.Item>
      <Nav.Link
        as={Link}
        to={route}
        key="attribution-data"
        eventKey="attribution-data"
      >
        Attribution Data
      </Nav.Link>
    </Nav.Item>
  );
};

export default AttributionNavItem;
